export interface RoleConfig {
    id: number;
    name: string;
    display: string;
    isAdmin: boolean;
    order: number;
}

export class Roles {
    public static readonly None: RoleConfig = { id: 0, name: "None", display: "None", isAdmin: false, order: 99 };
    public static readonly KuderAdmin: RoleConfig = { id: 1, name: "KuderAdmin", display: "Kuder Admin", isAdmin: true, order: 1 };
    public static readonly StateAdmin: RoleConfig = { id: 2, name: "StateAdmin", display: "State Admin", isAdmin: true, order: 2 };
    public static readonly DistrictAdmin: RoleConfig = { id: 3, name: "DistrictAdmin", display: "District Admin", isAdmin: true, order: 3 };
    public static readonly SchoolAdmin: RoleConfig = { id: 4, name: "SchoolAdmin", display: "School Admin / Counselor", isAdmin: true, order: 4 };
    public static readonly TeacherCounselorAdmin: RoleConfig = { id: 5, name: "TeacherCounselorAdmin", display: "Teacher", isAdmin: true, order: 5 };
    public static readonly Student: RoleConfig = { id: 6, name: "Student", display: "Student", isAdmin: false, order: 6 };

    public static All: RoleConfig[] = [
        Roles.KuderAdmin,
        Roles.StateAdmin,
        Roles.DistrictAdmin,
        Roles.SchoolAdmin,
        Roles.TeacherCounselorAdmin,
        Roles.Student
    ];

    public static FindById(id: number) {
        return this.All.find(x => x.id === id) || this.None;
    }

    /**
     * Returns a list of **admin** Roles that can be selected from the current role. These are Roles at or 'below' the current role
     *
     * Example: A DistrictAdmin would return **[DistrictAdmin, Teacher]**
     */
    public static GetRoleSelectionsByRole(role: RoleConfig) {
        return Roles.All.filter(x => x.order >= role.order && x.isAdmin && x !== Roles.KuderAdmin);
    }
}



// WEBPACK FOOTER //
// ./src/constants/Roles.ts